---
layout: blog
title: "Corral AI Now Available on Azure Marketplace"
date: "2024-12-10"
author: "Corral Team"
description: "Deploy Corral AI directly from the Azure Marketplace with one click. Get started in minutes with enterprise-grade AI that respects your security boundaries."
tags:
  - Azure
  - Launch
---

We're excited to announce that Corral AI is now available on the **Azure Marketplace**, making it easier than ever to deploy enterprise AI that respects your security boundaries.

## One-Click Deployment

Gone are the days of lengthy procurement cycles and complex infrastructure setup. With our Azure Marketplace listing, you can:

1. **Find us** in the Azure Marketplace
2. **Click deploy** and select your subscription
3. **Configure** your preferred settings
4. **Start using** Corral within minutes

No infrastructure team required. No DevOps tickets. No waiting.

## Why Azure Marketplace?

We chose Azure Marketplace as our primary distribution channel for several reasons:

### Simplified Procurement

Many enterprises have pre-approved Azure spending. Deploying through Marketplace means:

- No new vendor onboarding
- Consolidated billing through your existing Azure agreement
- Familiar procurement workflows

### Trust & Verification

Microsoft vets every application on the Marketplace. When you deploy Corral, you know:

- Our security practices meet Microsoft's standards
- Our application has been reviewed for quality
- Support and updates are guaranteed

### Native Integration

Deploying through Azure means Corral integrates seamlessly with:

- **Azure Active Directory** for authentication
- **Azure Key Vault** for secrets management
- **Azure Monitor** for observability
- **Azure Policy** for governance

## Getting Started

Ready to try Corral? Here's what to do:

1. Visit the [Azure Marketplace](https://azuremarketplace.microsoft.com)
2. Search for "Corral AI"
3. Click "Get It Now"
4. Follow the deployment wizard

The entire process takes less than 10 minutes for most organizations.

## Enterprise Support

Our Marketplace listing includes:

- **Standard tier** — For teams getting started with AI
- **Professional tier** — For departments scaling AI adoption
- **Enterprise tier** — For organization-wide deployments

All tiers include our zero-access architecture and managed infrastructure. Enterprise tier adds dedicated support, custom SLAs, and advanced compliance features.

---

*Questions about deployment? Our team is here to help. [Contact us](/company/contact) or check out our [documentation](/docs).*
